import React from 'react';
import { Select, SelectProps } from 'antd';
import { noop } from 'lodash';
import { useQuery } from 'react-query';
import { getBranchListByMgid, GetBranchListByMgidParams,  MgBranch,  } from 'services/parametersService';

export type ParListSelectBrancheProps = SelectProps<any> &{
  value?: any;
  params: GetBranchListByMgidParams;
  onChange?: (Branche: MgBranch) => void;
  onSelected?: (Branche: MgBranch) => void;
  disabled?: boolean;
  allowClear?: boolean;
  style?: any;
};

const ParListSelectBranche = ({
  value,
  params,
  onChange = noop,
  onSelected,
  ...otherProps
}: ParListSelectBrancheProps) => {
  const { data: Branche, isLoading } = useQuery(
    ['getBranchListByMgidSelect', params],
    () => getBranchListByMgid(params).then((res) => { return res.list || []}),
    { enabled: !!params }, 
  
    
  );

  const handleChange: SelectProps<any>['onChange'] = (value, option) => {
    onChange(value);
    if (onSelected) {
      if(value.tpidbroker)
      onSelected(Branche?.find((item) => item.brid === value.brid)!);
      else
      onSelected(Branche?.find((item) => item.brid === value)!);
    }
  };

  return (
    <Select
      onChange={handleChange}
      {...otherProps}
      loading={isLoading}
      allowClear
      value={!value?.brid?value:value.brid}
    >
      {Branche?.map((br) => (
        <Select.Option value={br.brid} key={br.brid}>
          {br.brname}
        </Select.Option>
      ))}
    </Select>
  );
};

export default ParListSelectBranche;
